<template>
    <div v-show="showPersonSelect" class="flex items-center">
      <SelectPersonDropdown @person-selected="handlePersonSelected" ref="selectPersonDropdown" :topPerson="getOwnerPerson"/>      
    </div>
</template>

<script>
import SelectPersonDropdown from '@/components/app/SelectPersonDropdown';
import { isPermitionAllowed, isPermitionAllowedForRole } from '@/permissions';
import { mapGetters } from 'vuex';

export default {
    name: "GlobalPersonDropdown",
    components: {                
        SelectPersonDropdown,
    },

    data() {        
        return {
            showPersonSelect: false,
        }
    },    
    
    computed: {
        ...mapGetters('user', ['getOwnerPerson']),

        role() {
            return this.$store.getters['user/getRoleCurentUser'];
        },

        currentPerson() {
            return this.$store.state.user.currentPerson
        }
    },

    watch: {
        role(newRole) {
            this.showPersonSelect = this.isPermitionAllowedForRole('gettingPersonList', newRole);
            console.log('new role:', newRole);
            this.$refs.selectPersonDropdown.refresh(); // Обновляем данные компонента
        },

        currentPerson: {
            handler(newPerson, oldPerson) {
                if (newPerson?.guid != oldPerson?.guid) {
                    console.log('currentPerson изменился:', oldPerson, '→', newPerson)
                    if (this.$refs.selectPersonDropdown) {
                        this.$refs.selectPersonDropdown.setPerson(newPerson)
                    }                
                }
            },
            deep: true,      // важны изменения его полей currentPerson
            //immediate: true  // сработает сразу при инициализации
        }
    },

    methods: {
        isPermitionAllowed, isPermitionAllowedForRole,

        handlePersonSelected(person) {            
            localStorage.setItem('currentPersonGuid', person?.guid);            
            this.$store.commit('user/SET_CURRENT_PERSON', person);  
            
            this.showPersonSelect = this.isPermitionAllowed('gettingPersonList');            
        },
    }
}
</script>

<style lang="scss" scoped>

</style>